// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip___sotRE","hit_card":"hit_card___lMOh1","block_wrapper":"block_wrapper___wRgqh"};